module.exports = __webpack_public_path__ + "img/check-mark.899369af.png";